module.exports = __webpack_public_path__ + "static/media/trouble.66bba847.svg";